import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../Documents/commonstyle.css';
import './SubscriptionFeatureRequired.css';

const SubscriptionFeatureRequired = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Read module from URL (?module=document) - more reliable than state
  const urlParams = new URLSearchParams(location.search);
  const module = urlParams.get('module');

  const handleGoToSubscription = () => {
    const params = new URLSearchParams();
    if (module) params.set('module', module);
    navigate(`/user-subscription${params.toString() ? '?' + params.toString() : ''}`);
  };

  return (
    <div className="subscription-feature-required">
      <div className="subscription-feature-required-card">
        <div className="subscription-feature-required-icon">
          <i className="fas fa-lock" aria-hidden="true"></i>
        </div>
        <p className="subscription-feature-required-message">
          Your current subscription doesn&apos;t have this feature. Upgrade your plan to access it.
        </p>
        <button
          type="button"
          className="btn doc-form-submit-btn"
          onClick={handleGoToSubscription}
        >
          <i className="fas fa-arrow-right me-2" aria-hidden="true"></i>
          Go to Subscription
        </button>
      </div>
    </div>
  );
};

export default SubscriptionFeatureRequired;
